/*@flow*/
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

export const GetIntersectingResources = (gql(`
  query GetIntersectingResources($theGeom: String!, $targetRelation: String!) {
    me {
      id
      company {
        id
        intersectingResources(
          theGeom: $theGeom
          targetRelation: $targetRelation
        ) {
          ... on Building {
            __typename
            id
            name
          }
        }
      }
    }
  }
`): DocumentNode);
